export default __webpack_public_path__ + "static/media/icon-ethereum-white.b19a5a16.png";